

function JumpToStep(newStepNumber, setStepNumber, setXIsNext) {
  let newXIsNext = ((newStepNumber % 2) === 0);
  setStepNumber(newStepNumber);
  setXIsNext(newXIsNext);
};

export default JumpToStep;
